import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Form } from 'antd';
import { FormInstance } from 'antd/es/form';
import { InitiativeLink } from '@sonar-software/sonar-core';
import { LinkInput } from './LinkInput';
import React from 'react';
import { SonarModal } from './modals';

export interface LinkModalProps {
	disabled?: boolean;
	link?: InitiativeLink;
	onCancel: () => void;
	onOk: (values: { title: string; url: string }) => void;
	open: boolean;
}

export interface LinkModalFormValues {
	title: string;
	url: string;
}

export class LinkModal extends React.Component<LinkModalProps> {
	linkFormRef = React.createRef<FormInstance<LinkModalFormValues>>();

	handleOnOkClick = (): void => {
		const { onOk } = this.props;
		const { current } = this.linkFormRef;

		current
			?.validateFields()
			.then((values) => {
				if (!values.title) {
					values.title = values.url;
				}

				onOk(values);
				current.resetFields();
			})
			.catch((info) => {
				throw new Error(info);
			});
	};

	handleOnCancelClick = (): void => {
		const { onCancel } = this.props;
		const { current } = this.linkFormRef;

		current?.resetFields();
		onCancel();
	};

	getInitialFieldValues = (link: InitiativeLink | undefined): { name: string; value: string }[] => {
		const { current } = this.linkFormRef;
		const title = current?.getFieldValue('title') || link?.title;
		const url = current?.getFieldValue('url') || link?.url;

		return [
			{
				name: 'title',
				value: title
			},
			{
				name: 'url',
				value: url
			}
		];
	};

	render(): React.ReactNode {
		const { disabled, open, link } = this.props;

		return (
			<SonarModal
				className='link-modal'
				okText={ link ? COPY_SPECIFIC.UPDATE : COPY_SPECIFIC.SAVE }
				onCancel={ this.handleOnCancelClick }
				onOk={ this.handleOnOkClick }
				open={ open }
				title={ link ? COPY_SPECIFIC.UPDATE_LINK : COPY_SPECIFIC.ADD_A_LINK }>
				<Form
					fields={ this.getInitialFieldValues(link) }
					ref={ this.linkFormRef }>
					<LinkInput disabled={ disabled } />
				</Form>
			</SonarModal>
		);
	}
}
